import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Internal Formly FieldType Component
 * Used internally by SelectWrapperComponent and Formly forms.
 * Do not use this directly - use SelectWrapperComponent instead.
 */
@Component({
  selector: 'era-formly-select-field',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormlyModule],
})
export class SelectComponent extends FieldType<FieldTypeConfig> {
  get placeholder(): string {
    return this.props.placeholder || '';
  }

  get required(): boolean {
    return this.props.required || false;
  }

  get disabled(): boolean {
    return this.props.disabled || false;
  }

  get selectOptions(): { label: string; value: unknown }[] {
    return (this.props.options as { label: string; value: unknown }[]) || [];
  }

  get labelPosition(): 'top' | 'inline' {
    return this.props.labelPosition || 'top';
  }

  get labelWidth(): string | undefined {
    return this.props.labelWidth;
  }
}
